/**
 * PATH: packages/ui/src/kanban/components/KanbanCardDetailSlot.tsx
 * FILE_ID: UI-KANBAN-CARD-DETAIL-001
 * PURPOSE: Render the optional card-detail divider only around visible detail.
 * WHY: Empty producer slots must not reserve space on a card.
 * FLOW: ReactNode input → renderability guard → optional detail wrapper.
 * RELATED: KanbanCard.tsx; Time and Smart Time detail-slot producers.
 */
import type { ReactNode } from 'react'

import { hasRenderableCardDetail } from './cardDetailContent'

export function KanbanCardDetailSlot({ content }: { content: ReactNode }) {
  if (!hasRenderableCardDetail(content)) return null

  return (
    <div
      data-card-detail-slot=""
      className="mt-1.5 border-t border-neutral-100 pt-1.5 dark:border-zinc-700/70"
    >
      {content}
    </div>
  )
}
